const setSocketMessageNotificationVisible = ({
  type,
  data,
  onClose,
}: {
  type: string;
  data: any;
  onClose: () => void;
}) => {
  if (type === 'accounts-create' && data?.eventType === 'ON_ACCOUNT_CREATE') {
    onClose();
  }

  if (
    type === 'psp-accounts-create' &&
    data?.eventType === 'ON_PSP_ACCOUNT_CREATE'
  ) {
    onClose();
  }

  if (
    type === 'accounts' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('accounts')
  ) {
    onClose();
  }

  if (
    type === 'corporate-client-account-create' &&
    data?.eventType === 'ON_ACCOUNT_CREATE' &&
    data?.content?.organizationType === 'CORPORATE'
  ) {
    onClose();
  }

  if (
    type === 'individual-client-account-create' &&
    data?.eventType === 'ON_ACCOUNT_CREATE' &&
    data?.content?.organizationType === 'INDIVIDUAL'
  ) {
    onClose();
  }

  if (
    (type === 'corporate-client-outgoing-monitoring' &&
      data?.eventType === 'ON_FILE_READY' &&
      data?.content?.name?.includes('ongoing-monitoring')) ||
    (type === 'individual-client-outgoing-monitoring' &&
      data?.eventType === 'ON_FILE_READY' &&
      data?.content?.name?.includes('ongoing-monitoring'))
  ) {
    onClose();
  }

  if (
    type === 'bs-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('balance-sheet')
  ) {
    onClose();
  }

  if (
    type === 'banks-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('banks-balance-sheet')
  ) {
    onClose();
  }

  if (
    type === 'capital-adequacy-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('capital-adequacy-balance-sheet')
  ) {
    onClose();
  }

  if (
    type === 'currency-position-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('currency-position')
  ) {
    onClose();
  }

  if (
    type === 'profit-loss-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('profit-loss')
  ) {
    onClose();
  }

  if (
    type === 'safeguarding-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('safeguarding-balance-sheet')
  ) {
    onClose();
  }

  if (
    type === 'warnings-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('warnings-reports')
  ) {
    onClose();
  }

  if (
    type === 'warnings-list-report' &&
    data?.eventType === 'ON_FILE_READY' &&
    (data?.content?.name?.includes('warnings.csv.gz') ||
      data?.content?.name?.includes('warnings.csv'))
  ) {
    onClose();
  }

  if (
    type === 'payments-orders' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('payments-orders') &&
    !data?.content?.name?.includes('beneficiaries')
  ) {
    onClose();
  }

  if (
    type === 'payments-orders-beneficiaries' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('payments-orders-beneficiaries')
  ) {
    onClose();
  }

  if (
    type === 'exchange' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('exchange-transactions')
  ) {
    onClose();
  }

  if (
    type === 'general-ledger' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('general-ledger-transactions')
  ) {
    onClose();
  }

  if (
    type === 'incoming' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('incoming-transactions')
  ) {
    onClose();
  }

  if (
    type === 'internal' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('internal-transactions')
  ) {
    onClose();
  }

  if (
    type === 'nostro' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('nostro-transactions')
  ) {
    onClose();
  }

  if (
    type === 'outgoing' &&
    data?.eventType === 'ON_FILE_READY' &&
    data?.content?.name?.includes('outgoing-transactions')
  ) {
    onClose();
  }
};

export default setSocketMessageNotificationVisible;
